export enum ValidatorFormEntityEnum {
    ORDER_SETUP_STEP_1_NUMBER_OF_SAMPLES,
    ORDER_SETUP_STEP_2_SAMPLE_NAME,
    ORDER_SETUP_STEP_2_BARCODE,
    ORDER_SETUP_STEP_2_SIZE,
    ORDER_SETUP_STEP_2_DNA_TYPE,
    ORDER_SETUP_STEP_2_PRIMER,
    CUSTOM_PRIMER_NAME,
    CUSTOM_PRIMER_SEQUENCE,
    SHIPPED_PRIMER_NAME,
    SHIPPED_PRIMER_BARCODE,
    ADD_NEW_INFORMED_USER_FIRST_NAME,
    ADD_NEW_INFORMED_USER_LAST_NAME,
    ADD_NEW_INFORMED_USER_EMAIL,
    RESULTS_PRIMER_DRAWER_PRIMER_NAME,
}
